import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "search-result-count" }
const _hoisted_2 = {
  key: 0,
  class: "find-all-active",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_6827_110032)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.6197 5.33325H5.81017C5.54696 5.33325 5.33398 5.54635 5.33398 5.80944V9.61897C5.33398 9.88087 5.54696 10.0952 5.81017 10.0952C6.07339 10.0952 6.28637 9.88087 6.28637 9.61897V6.28563H9.6197C9.8816 6.28563 10.0959 6.07254 10.0959 5.80944C10.0959 5.54635 9.8816 5.33325 9.6197 5.33325ZM9.6197 17.7142H6.28637V14.3809C6.28637 14.119 6.07327 13.9047 5.81017 13.9047C5.54708 13.9047 5.33398 14.119 5.33398 14.3809V18.1904C5.33398 18.4523 5.54696 18.6666 5.81017 18.6666H9.6197C9.8816 18.6666 10.0959 18.4523 10.0959 18.1904C10.0959 17.9285 9.8816 17.7142 9.6197 17.7142ZM18.1911 13.9047C17.9279 13.9047 17.7149 14.1177 17.7149 14.3809V17.7142H14.3816C14.1184 17.7142 13.9054 17.9272 13.9054 18.1904C13.9054 18.4536 14.1184 18.6666 14.3816 18.6666H18.1911C18.4543 18.6666 18.6673 18.4536 18.6673 18.1904V14.3809C18.6673 14.119 18.453 13.9047 18.1911 13.9047ZM18.1911 5.33325H14.3816C14.1197 5.33325 13.9054 5.54635 13.9054 5.80944C13.9054 6.07254 14.1197 6.28563 14.3816 6.28563H17.7149V9.61897C17.7149 9.88087 17.9292 10.0952 18.1911 10.0952C18.453 10.0952 18.6673 9.88087 18.6673 9.61897V5.80944C18.6673 5.54635 18.453 5.33325 18.1911 5.33325Z",
    fill: "#544DC7"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.66602 11.1667C8.66602 12.5454 9.8289 13.6667 11.2586 13.6667C11.8176 13.6667 12.3324 13.4914 12.7564 13.2001L14.41 14.7946C14.4939 14.8751 14.6047 14.9167 14.7154 14.9167C14.8261 14.9167 14.9365 14.8761 15.0208 14.7947C15.1896 14.6319 15.1896 14.3681 15.0208 14.2056L13.3672 12.6111C13.6703 12.2032 13.8512 11.7058 13.8512 11.1667C13.8512 9.7881 12.6883 8.66675 11.2586 8.66675C9.8289 8.66675 8.66602 9.78914 8.66602 11.1667ZM12.987 11.1667C12.987 12.0855 12.2114 12.8334 11.2586 12.8334C10.3058 12.8334 9.53021 12.0855 9.53021 11.1667C9.53021 10.248 10.3058 9.50008 11.2586 9.50008C12.2114 9.50008 12.987 10.2475 12.987 11.1667Z",
    fill: "#544DC7"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_6827_110032" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "24",
      height: "24",
      rx: "12",
      fill: "white"
    })
  ])
], -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  width: "24",
  class: "find-all-inactive",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_6827_77972)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.6197 5.33325H5.81017C5.54696 5.33325 5.33398 5.54635 5.33398 5.80944V9.61897C5.33398 9.88087 5.54696 10.0952 5.81017 10.0952C6.07339 10.0952 6.28637 9.88087 6.28637 9.61897V6.28563H9.6197C9.8816 6.28563 10.0959 6.07254 10.0959 5.80944C10.0959 5.54635 9.8816 5.33325 9.6197 5.33325ZM9.6197 17.7142H6.28637V14.3809C6.28637 14.119 6.07327 13.9047 5.81017 13.9047C5.54708 13.9047 5.33398 14.119 5.33398 14.3809V18.1904C5.33398 18.4523 5.54696 18.6666 5.81017 18.6666H9.6197C9.8816 18.6666 10.0959 18.4523 10.0959 18.1904C10.0959 17.9285 9.8816 17.7142 9.6197 17.7142ZM18.1911 13.9047C17.9279 13.9047 17.7149 14.1177 17.7149 14.3809V17.7142H14.3816C14.1184 17.7142 13.9054 17.9272 13.9054 18.1904C13.9054 18.4536 14.1184 18.6666 14.3816 18.6666H18.1911C18.4543 18.6666 18.6673 18.4536 18.6673 18.1904V14.3809C18.6673 14.119 18.453 13.9047 18.1911 13.9047ZM18.1911 5.33325H14.3816C14.1197 5.33325 13.9054 5.54635 13.9054 5.80944C13.9054 6.07254 14.1197 6.28563 14.3816 6.28563H17.7149V9.61897C17.7149 9.88087 17.9292 10.0952 18.1911 10.0952C18.453 10.0952 18.6673 9.88087 18.6673 9.61897V5.80944C18.6673 5.54635 18.453 5.33325 18.1911 5.33325Z",
    fill: "#40484C"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.66602 11.1667C8.66602 12.5454 9.8289 13.6667 11.2586 13.6667C11.8176 13.6667 12.3324 13.4914 12.7564 13.2001L14.41 14.7946C14.4939 14.8751 14.6047 14.9167 14.7154 14.9167C14.8261 14.9167 14.9365 14.8761 15.0208 14.7947C15.1896 14.6319 15.1896 14.3681 15.0208 14.2056L13.3672 12.6111C13.6703 12.2032 13.8512 11.7058 13.8512 11.1667C13.8512 9.7881 12.6883 8.66675 11.2586 8.66675C9.8289 8.66675 8.66602 9.78914 8.66602 11.1667ZM12.987 11.1667C12.987 12.0855 12.2114 12.8334 11.2586 12.8334C10.3058 12.8334 9.53021 12.0855 9.53021 11.1667C9.53021 10.248 10.3058 9.50008 11.2586 9.50008C12.2114 9.50008 12.987 10.2475 12.987 11.1667Z",
    fill: "#40484C"
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_6827_77972" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "24",
      height: "24",
      rx: "12",
      fill: "white"
    })
  ])
], -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "io-mfe-ig-search-bar-text-container" }
const _hoisted_11 = { class: "io-mfe-ig-search-bar-text-container" }

import {ref, computed, Ref, watch} from 'vue';
import debounce from 'lodash.debounce';
import { isEmpty } from 'src/common/stringUtil';
import { isEmpty as isArrayEmpty} from 'src/common/arrayUtil';
import {QInput, QList, QMenu} from 'quasar';
import { useElementSize } from '@vueuse/core'
import {useGrouperStore} from 'stores/grouper-store';
import {storeToRefs} from 'pinia';
import {useSearchStore} from "stores/search-store";


export type GenericSearchOption = {[key: string]: unknown} | string;

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBar',
  props: /*#__PURE__*/_mergeModels({
    className: { default: '' },
    keyProp: {},
    search: {},
    resultDisplay: {},
    showResultsMenu: { type: Boolean, default: true },
    autoSearch: { type: Boolean, default: true },
    showFindAll: { type: Boolean, default: false },
    disable: { type: Boolean },
    searchOnFocus: { type: Boolean },
    searchHistory: {},
    showSearchHistory: { type: Boolean },
    shouldRerender: { type: Boolean, default: false }
  }, {
    "modelValue": { default: '' },
    "modelModifiers": {},
    "results": { default: <GenericSearchOption[]>[]},
    "resultsModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(["item-selected", "search"], ["update:modelValue", "update:results"]),
  setup(__props: any, { expose: __expose, emit: __emit }) {

const searchText = _useModel(__props, "modelValue");
const results = _useModel(__props, 'results');
const inputRef = ref<InstanceType<typeof QInput>>();
const { width } = useElementSize(inputRef);
const searchMenuOpen = ref(false);
const searchInputKey = ref(0);
const searchMenuInputKey = ref(0);
const searchMenuRef = ref<InstanceType<typeof QMenu>>();

const grouperStore = useGrouperStore();
const {findAll} = storeToRefs(grouperStore);

const searchStore = useSearchStore();
const {searchFocused} = storeToRefs(searchStore);



// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = __props;

const emit = __emit;

const searchCountText = computed(() => {
  if (typeof resultsCount.value === 'number' && displaySearchResults.value) {
    return `${resultsCount.value} result${resultsCount.value != 1 ? 's' : ''}`;
  }
  return '';
});

let displaySearchResults = ref<boolean>(props.autoSearch);
let autoSearchEnabled = ref<boolean>(true);
let selectedResultIndex = ref<number>(0);
let selectedHistoryIndex = ref<number>(0);

watch(
  results,
  (newResults) => {
    selectedResultIndex.value = 0;
  });

function updateDisplaySearchResults(display: boolean){
  displaySearchResults.value = props.autoSearch ? true : display;
}

function clear() {
  searchText.value = '';
  searchMenuOpen.value = false;
  updateDisplaySearchResults(false);
  makeHistoryVisible();
  inputRef?.value?.focus();
  selectedResultIndex.value = 0;
}

function onClick(result: GenericSearchOption, event: Event){
  if(event instanceof PointerEvent){
    selectedResultIndex.value = results.value.indexOf(result);
    emit('item-selected', result);
  }
}
function onKeyboardPressed(event: KeyboardEvent){
  if (['ArrowUp', 'ArrowDown', 'Enter', 'Tab'].includes(event.key)){
    if ((showingHistory.value && historyItems.value) || (!showingHistory.value && results.value)){
      let currentIndex = showingHistory.value ? selectedHistoryIndex.value : selectedResultIndex.value;
      if (event.key === 'ArrowUp'){
        if(currentIndex > 0) {
          showingHistory.value ? selectedHistoryIndex.value = currentIndex - 1 : selectedResultIndex.value = currentIndex - 1;
        }
      } else if (event.key === 'ArrowDown' || event.key === 'Tab'){
        if (showingHistory.value){
          if(currentIndex < historyItems.value.length - 1) selectedHistoryIndex.value = currentIndex + 1;
        } else {
          if(currentIndex < results.value.length - 1) selectedResultIndex.value = currentIndex + 1;
        }
      } else if (event.key === 'Enter'){
        showingHistory.value ? updateHistory(historyItems.value[selectedHistoryIndex.value]) : emit('item-selected', results.value[currentIndex]);
      }
    }
  }
}

function changeFindAll() {
  grouperStore.changeFindAllSearch();
  search();
}

function findAllText(): string {
  return !!findAll.value ? "Turn Off 'Find All' to search for terms within the structure of the index." :  "Turn On 'Find All' to search for terms outside of the structure of the index.";
}

function validText(): boolean {
  return !!searchText.value && searchText.value.length >= 3;
}

const search = debounce(async () => {
  if(searchFocused.value) {
    autoSearchEnabled.value = false;
    searchFocused.value = false;

    spanRefMap = new Map<string, Ref>();
    overflowMap = new Map<string, Ref<boolean>>();
    if (!validText() || !props.search) {
      results.value = [];
      return;
    }

    const searchResults = await props.search(searchText.value, findAll.value);

    updateDisplaySearchResults(true);

    searchMenuOpen.value = !!searchResults?.length && props.showResultsMenu;
    results.value = searchResults;

    emit('search', results.value);
    if (props.shouldRerender) {
      searchInputKey.value++;
      searchMenuInputKey.value++;
    }

    setTimeout(() => {
      autoSearchEnabled.value = true;
    }, 3000);
  }
}, 300);

function focusMenu(){
  if (searchMenuOpen.value == true){
    searchMenuRef?.value?.focus();
  }
}
let spanRefMap: Map<string, Ref> = new Map<string, Ref<Element>>();
let overflowMap: Map<string, Ref<boolean>> = new Map<string, Ref<boolean>>();

function getOptionSpanRef(opt: GenericSearchOption): Ref {
  const key = getKey(opt);

  if (spanRefMap.has(key)) {
    return <Ref>spanRefMap.get(key);
  }

  const spanRef = ref(null);
  spanRefMap.set(key, spanRef);
  return spanRef;
}

function getOverflowRef(opt: GenericSearchOption): Ref {
  const key = getKey(opt);
  let overflowRef: Ref<boolean>;

  if (overflowMap.has(key)) {
    overflowRef = <Ref>overflowMap.get(key);
  } else {
    overflowRef = ref(false);
    overflowMap.set(key, overflowRef);
  }

  // we do this in setTimeout to give time for the app to actually render the menu
  // if we don't do this, the elements don't have widths because they aren't on
  // the screen yet
  setTimeout(() => {
    overflowRef.value = searchResultOverflowed(opt);
  });

  return overflowRef;
}

function getKey(option: GenericSearchOption): string {

  if (typeof option === 'string') {
    return option;
  } else if (props.keyProp && option.hasOwnProperty(props.keyProp)) {
    return <string>option[props.keyProp];
  }

  return '';
}

function searchResultOverflowed(option: GenericSearchOption): boolean {

  const element = getOptionSpanRef(option);

  if (element?.value?.[0]) {
   return element?.value?.[0]?.offsetWidth < element?.value?.[0]?.scrollWidth;
  }

  return false;
}

const resultsCount = computed(() => {
  return validText() ? results.value.length : '';
});

function resultDisplayText(result: GenericSearchOption): string {
  if (!props.resultDisplay) {
    return <string>result;
  }

  if (typeof props.resultDisplay === 'string' && typeof result === 'object') {
    return <string>result[props.resultDisplay];
  } else if (typeof props.resultDisplay === 'function') {
    return props.resultDisplay(result);
  } else {
    return <string>result;
  }
}

function onFocus() {
  if(autoSearchEnabled.value) {
    searchFocused.value = true;
    if (validText() && props.searchOnFocus) {
      search();
    } else {
      // focus open search history
      makeHistoryVisible();
    }
  }
}

function getHistoryKey(search: string): string {
  return `search-${search}`;
}

function onHistoryClick(term: string, event: Event) {
  if (event instanceof PointerEvent){
    updateHistory(term)
  }
}

function updateHistory(term: string){
  selectedHistoryIndex.value = 0;
  searchMenuOpen.value = false;
  searchText.value = term;
  search();
}

function makeHistoryVisible() {

  searchMenuOpen.value = props.showSearchHistory && !isArrayEmpty(props.searchHistory);
}

function textUpdated() {

  searchFocused.value = true;

  makeHistoryVisible();

  if (props.autoSearch) {
    search();
  }
}

const showingHistory = computed(() => {
  return props.showSearchHistory && searchMenuOpen.value;
});

const historyItems = computed(() => {
  return (props.searchHistory || []).filter(item => isEmpty(searchText.value) || item.toLowerCase().indexOf(searchText.value.toLowerCase()) != -1);
})

watch(
  historyItems,
  () => {
    selectedHistoryIndex.value = 0;
  });

__expose({
  search
});


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_unref(QInput), {
      dense: "",
      outlined: "",
      modelValue: searchText.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
        textUpdated
      ],
      key: searchInputKey.value,
      label: "Search for a term or code...",
      class: _normalizeClass(`${_ctx.className}-search-input`),
      for: "search-input",
      autocomplete: "off",
      onKeydown: [
        _withKeys(_withModifiers(_unref(search), ["prevent"]), ["enter"]),
        _withKeys(focusMenu, ["tab"])
      ],
      disable: _ctx.disable,
      onFocus: onFocus,
      debounce: 300,
      ref_key: "inputRef",
      ref: inputRef
    }, {
      append: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(searchCountText.value), 1),
        _withDirectives(_createVNode(_component_q_icon, {
          name: "fa-regular fa-xmark",
          class: "cursor-pointer",
          onClick: clear
        }, null, 512), [
          [_vShow, searchText.value !== '']
        ]),
        _createVNode(_component_q_separator, { vertical: "" }),
        _createVNode(_component_q_icon, {
          name: "fa-regular fa-magnifying-glass",
          class: "cursor-pointer",
          onClick: _unref(search)
        }, null, 8, ["onClick"]),
        (_ctx.showFindAll)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "col-mb-1 find-all-container",
              onClick: changeFindAll
            }, [
              _createVNode(_component_q_tooltip, {
                anchor: "bottom left",
                self: "center left"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(findAllText()), 1)
                ]),
                _: 1
              }),
              (_unref(findAll))
                ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_5))
                : (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_9))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "class", "onKeydown", "disable"])),
    (_ctx.showResultsMenu || _ctx.showSearchHistory)
      ? (_openBlock(), _createBlock(_unref(QMenu), {
          class: _normalizeClass(`io-mfe-ig-search-menu-portal`),
          modelValue: searchMenuOpen.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchMenuOpen).value = $event)),
          "no-parent-event": true,
          "no-focus": true,
          target: `.${_ctx.className}-search-input`,
          anchor: "bottom left",
          "max-width": _unref(width) + 'px',
          width: _unref(width) + 'px',
          "max-height": showingHistory.value ? '240px' : '200px',
          fit: "",
          ref_key: "searchMenuRef",
          ref: searchMenuRef,
          key: searchMenuInputKey.value
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(QList), null, {
              default: _withCtx(() => [
                (!showingHistory.value)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(results.value, (result, index) => {
                      return (_openBlock(), _createBlock(_component_q_item, {
                        key: index,
                        clickable: "",
                        "manual-focus": "",
                        "no-hover": false,
                        onClick: _withModifiers(($event: any) => (onClick(result, $event)), ["prevent","stop"]),
                        onKeydown: _withModifiers(onKeyboardPressed, ["prevent","stop"]),
                        class: _normalizeClass('q-hoverable' + ((index === _unref(selectedResultIndex)) ? ' result-item__active' : ''))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("span", {
                                      ref_for: true,
                                      ref: getOptionSpanRef(result),
                                      class: "full-width"
                                    }, _toDisplayString(resultDisplayText(result)), 513)
                                  ]),
                                  _createVNode(_component_q_icon, {
                                    class: "io-mfe-ig-icon-small on-hover",
                                    name: "fa-regular fa-circle-plus",
                                    size: "16px"
                                  }),
                                  (getOverflowRef(result).value)
                                    ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(resultDisplayText(result)), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "class"]))
                    }), 128))
                  : _createCommentVNode("", true),
                (showingHistory.value)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(historyItems.value, (result, index) => {
                      return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                        key: index,
                        clickable: "",
                        "manual-focus": "",
                        "no-hover": false,
                        onClick: ($event: any) => (onHistoryClick(result, $event)),
                        onKeydown: _withModifiers(onKeyboardPressed, ["prevent","stop"]),
                        class: _normalizeClass('q-hoverable' + ((index === _unref(selectedHistoryIndex)) ? ' result-item__active' : ''))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    class: "io-mfe-ig-icon-medium",
                                    name: "fa-regular fa-clock-rotate-left"
                                  }),
                                  _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("span", {
                                      class: "full-width",
                                      ref_for: true,
                                      ref: getOptionSpanRef(result)
                                    }, _toDisplayString(result), 513)
                                  ]),
                                  (getOverflowRef(result).value)
                                    ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(result), 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "class"])), [
                        [_directive_close_popup]
                      ])
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "target", "max-width", "width", "max-height"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})